export default Object.freeze({
  GSS_URL: 'https://docs.google.com/spreadsheets/d/1fNds-uxkpIezPASkzOJujRkqTmxVf4HdKFZjMXVPurQ/edit#gid=1255465937',
  TOKEN: 'xoxb-4366482398-6330403300498-jjYj4LjDIbCGMYL8WBzNlRlu',
  CHANNEL: '#総務-企業ページお問い合わせ',
  POST_URL: 'https://docs.google.com/forms/d/e/1FAIpQLSdyJqne8LWIueZZCr-9ntld9ErT0Ml_QfWXz4NKwADclYhs1A/formResponse',
  FORM: {
    subject: 'entry.2051981835',
    phone: 'entry.2067646486',
    companyName: 'entry.1910706083',
    firstName: 'entry.209926591',
    lastName: 'entry.339360867',
    firstNameKana: 'entry.1121714836',
    lastNameKana: 'entry.1611086794',
    email: 'entry.102151385',
    message: 'entry.1993050287'
  }
})



// WEBPACK FOOTER //
// ./src/const/contact.js